import React from 'react';
import styled from 'styled-components'
import SearchInput from '../../Components/SearchInput'
import Button from '../../Components/Button';
import { media } from '../../styles/Mixin';
import NormalText from '../../Components/NormalText';
import Avatar from '../../Components/Avatar';

export default({
    onSubmit,
    data,
    loading,
    recentSee,
    setRecentSee,
    search,
    searchUser,
    searchUserLoading,
    called,
    history
})=>{
    // console.log("called", called, "loading", searchUserLoading, "data", searchUser)
    return(
        <Wrapper>
            <Box>
                <form onSubmit={onSubmit}>
                <SearchBox>
                    <SearchInput placeholder={"채널명을 검색해주세요 😁"} {...search} required={true}/>
                    <SearchButton text={"검색"} backgroundColor={"blue"}/>
                </SearchBox>
                <ContentBox loadingState={loading} >
                    {
                        loading &&
                        (
                            <LoadingText text={"최근 활동한 사용자를 불러오는 중입니다 ..."}/>
                        )
                    }
                    {
                        !loading && recentSee &&
                        (
                            <RecentSeeText text={"최근 사용자 가리기👆"} onClick={() => { setRecentSee(false)}}/>
                        )
                    }
                    {
                        !loading && !recentSee &&
                        (
                            <RecentSeeText text={"최근 사용자 보기👇"} onClick={() => { setRecentSee(true)}}/>
                        )
                    }
                        <RecentUserBox>
                    {
                        !loading && data && recentSee && 
                        data.seeRecentUser.map((recentUser, i)=>(
                            <AvatarBox key={i} onClick={()=>{
                                history.push(`/${recentUser.channelId}`)
                            }}>
                                <Avatar url={recentUser.profileImageUrl} size={"l_md"}/>
                                <CNormalText text={recentUser.displayName}/>
                            </AvatarBox>
                        ))
                    }
                        </RecentUserBox>                            
                </ContentBox>
                <ResultBox>
                    {
                        called && searchUserLoading && 
                        (
                            <NormalText text={"검색중..."}/>
                        )
                    }
                    {
                        !searchUserLoading && searchUser && searchUser.searchUser.length > 0 &&
                        searchUser.searchUser.map((user,i)=>(
                            <AvatarBox key={i} onClick={()=>{
                                history.push(`/${user.channelId}`)
                            }}>
                                <Avatar url={user.profileImageUrl} size={"l_md"}/>
                                <CNormalText text={user.displayName}/>
                            </AvatarBox>
                        ))
                    }
                    {
                            !searchUserLoading && searchUser && searchUser.searchUser.length === 0 &&
                            (
                                <NormalText text={"Nothing..😅"}/>
                            )
                    }
                </ResultBox>
                </form>
            </Box>
        </Wrapper>
    )
}



const Wrapper = styled.div`
    display:flex;
    justify-content:center;
    align-items:center;
    width:100%;
    min-height:20vh;
`

const Box = styled.div`
    width:100%;
    display:flex;
    flex-direction:column;
    align-items:center;
    form{
        width:100%;
        display:flex;
        flex-direction:column;
        align-items:center;
    }
`

const SearchBox = styled.div`
    width:100%;
    display:flex;
    flex-direction:column;
    align-items:center;
    &>:first-child{
        margin-bottom:20px;
    }
`

const SearchButton = styled(Button)`
    ${media.deskTop`max-width:32%;`}
`

const ContentBox = styled.div`
    width:100%;
    height:100%;
    display:flex;
    flex-direction:column;
    align-items:center;
`

const RecentSeeText = styled(NormalText)`
    color:${props => props.theme.blueColor};
    padding-top:20px;
    cursor:pointer;
`

const RecentUserBox = styled.div`
    display:flex;
    flex-direction:row;
    justify-content:center;
    flex-flow:wrap;
`

const AvatarBox = styled.div`
    padding: 20px;
    display:flex;
    flex-direction:column;
    align-items:center;
    cursor:pointer;
`

const LoadingText = styled(NormalText)`
    padding:20px;
`

const CNormalText = styled(NormalText)`
    padding:5px;
`


const ResultBox = styled.div`
    padding: 20px;
    display:flex;
    flex-direction:row;
    justify-content:center;
    flex-flow:wrap;
`

